import React, { useCallback } from 'react';

import BroadcastCard from 'components/cards/BroadcastCard';
import Recommendations from 'components/Recommendations';

import CommonPropTypes from 'utils/propTypes/common';

const RecommendationsBlock = ({ recommendations, personalRecommendations }) => {
	const renderCard = useCallback(
		(entity, onCardClick) => (
			<BroadcastCard
				data={entity}
				onClick={onCardClick}
				size="elastic"
				gutter="small"
				withInstitute={false}
				theme={null}
			/>
		),
		[]
	);

	return (
		<Recommendations
			type="broadcast"
			TitleTag="h1"
			markupBlocks={{
				section: { 'data-best': 'all' },
				pagination: { 'data-best': 'scroll' }
			}}
			{...{ recommendations, personalRecommendations, renderCard }}
		/>
	);
};

RecommendationsBlock.propTypes = {
	recommendations: CommonPropTypes.entities.isRequired,
	personalRecommendations: CommonPropTypes.entities
};

export default RecommendationsBlock;
